import { jsx as _jsx } from "react/jsx-runtime";
import { ModalCloseButton as ChakraModalCloseButton } from '@chakra-ui/react';
import { ThemeIconSizeVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icon, Icons } from '@caspeco/casper-ui-library.components.icon';
/**
 * ModalCloseButton is used closes the modal.
 * You don't need to pass the onClick to it, it reads the onClose action from the modal context.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/modal
 */
export function ModalCloseButton({ isAbsolutePositioned = false, }) {
    if (isAbsolutePositioned) {
        return (_jsx(ChakraModalCloseButton, { position: "absolute", zIndex: 1, top: ThemeSpaceVariable.Medium, right: ThemeSpaceVariable.Medium, children: _jsx(Icon, { icon: Icons.Close, size: ThemeIconSizeVariable.Medium }) }));
    }
    return (_jsx(ChakraModalCloseButton, { children: _jsx(Icon, { icon: Icons.Close, size: ThemeIconSizeVariable.Medium }) }));
}
//# sourceMappingURL=modalCloseButton.js.map